import { ShoppableResponseType, ShoppableReqType } from '../types/api/cta-shoppable-api';
import { Method, callAxios } from '../axios';

export const ctaShoppableApiFetchers = {
  getShopSeRedirectionLink: async ({ url, query, store }: ShoppableReqType) => {
    try {
      const response = await callAxios<{
        response: ShoppableResponseType;
      }>({
        method: Method.POST,
        url,
        data: { query },
        headers: {
          store,
        },
      });
      return { result: response.data, error: null };
    } catch (error) {
      return { result: null, error };
    }
  },
};
